if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productForm = this.productSection.querySelector('product-form');
      this.formPosition = 'visible';

      this.update = this.update.bind(this);
      this.updateBodyPadding = this.updateBodyPadding.bind(this);
    }

    connectedCallback() {
      if (!this.productForm || !('IntersectionObserver' in window)) return;

      this.observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          this.formPosition = 'visible';
        } else {
          this.formPosition = entry.boundingClientRect.bottom <= 0 ? 'above' : 'below';
        }
        this.update();
      });
      this.observer.observe(this.productForm);

      window.addEventListener('on:breakpoint-change', this.update);

      this.resizeObserver = new ResizeObserver(this.updateBodyPadding);
      this.resizeObserver.observe(this);
      document.body.classList.add('has-sticky-atc-panel');
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.resizeObserver) this.resizeObserver.disconnect();
      window.removeEventListener('on:breakpoint-change', this.update);
      document.body.classList.remove('has-sticky-atc-panel', 'sticky-atc-panel-visible');
    }

    /**
     * Desktop/tablet: show once the buy buttons are scrolled out above the viewport.
     * Mobile: show whenever the buy buttons are not visible, also below the viewport.
     * Shown for sold-out variants too, with a disabled "sold out" button (rendered in Liquid).
     */
    update() {
      const visible = theme.mediaMatches.md
        ? this.formPosition === 'above'
        : this.formPosition !== 'visible';

      this.classList.toggle('sticky-atc-panel--out', !visible);
      document.body.classList.toggle('sticky-atc-panel-visible', visible);
    }

    updateBodyPadding() {
      document.body.style.setProperty('--sticky-atc-panel-height', `${this.offsetHeight}px`);
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
